import React, { Fragment, Component, useState, useEffect, useRef } from 'react';
import constants from '../../../constants';
import { translate } from '../../../Services/translation';
import { useCookies } from 'react-cookie';

const CookieConsent = (props) => {
  const wrapperEl = useRef();
  const cookeConsent = constants.cookieConsent || {};
 
  const [cookies, setCookie, removeCookie] = useCookies(['cookie_consent', {}]);
  const {
    features = cookeConsent
      ? cookeConsent.enableFeatures
      : features === undefined
      ? true
      : features === 'true',
    analytics = cookeConsent
      ? cookeConsent.enableAnalytics
      : analytics === undefined
      ? true
      : analytics === 'true',
    marketing = cookeConsent
      ? cookeConsent.enableMarketing
      : marketing === undefined
      ? true
      : marketing === 'true',
  } = props;
  // Giving user the possibility to choose types of Cookies
  const [enableSettings, setEnableSettings] = useState(true);
    
  const [settingsVisible, setSettingsVisible] = useState(false);
  const [featuresIsActive, setFeaturesIsActive] = useState(features);
  const [analyticsIsActive, setAnalyticsIsActive] = useState(analytics);
  const [marketingIsActive, setMarketingIsActive] = useState(marketing);
  const [saveValues, setSaveValues] = useState(false);
  const [delayClose, setDelayClose] = useState(false);
  const [cookiebarVisible, setCookiebarVisible] = useState(
    props.cookiebarVisible
  );
  const [showButton, setShowButton] = useState(props.showButton);
  const [hostname, setHostName] = useState(() => {
    let host = window.location.host;
    const postIndx = host.indexOf(':');
    if (host !== -1) {
      host = host.substring(0, postIndx);
    }
    return host;
  });

  const [featuresStatusTxt, setFeaturesStatusTxt] = useState(() => {
    return translate(
      'addons.cookieconsent.' + (features ? 'active' : 'disabled')
    );
  });
  const [analyticsStatusTxt, setAnalyticsStatusTxt] = useState(() => {
    return translate(
      'addons.cookieconsent.' + (analytics ? 'active' : 'disabled')
    );
  });
  const [marketingStatusTxt, setMarketingStatusTxt] = useState(() => {
    return translate(
      'addons.cookieconsent.' + (marketing ? 'active' : 'disabled')
    );
  });

  useEffect(() => {
    if (saveValues) {
      setCookieValues();
    }
  }, [saveValues]);

  const showSettings = () => {
    setSettingsVisible(true);
    setCookiebarVisible(false);
  };

  const acceptCookiesWithDelay = () => {
    setTimeout(() => {
      acceptAllCookies(delayClose);
      //location.reload();
    }, 999);
  };

  const getCookieExpiresDate = () => {
    var now = new Date();
    now.setTime(now.getTime() + 3600 * 24 * 365 * 1111);
    return now; //.toUTCString();
  };

  const setCookieValues = (delayClose) => {
    const cookieExpires = getCookieExpiresDate();
    const cookieVal =
      (featuresIsActive ? 'features,' : '') +
      (analyticsIsActive ? 'analytics,' : '') +
      (marketingIsActive ? 'marketing,' : '');

    const cookieOptions = {
      expires: cookieExpires,
      path: '/',
      domain: hostname,
    };
    setCookie('cookie_consent', cookieVal, cookieOptions);

    //document.cookie =
    //  'cookie_consent=' +
    //  (featuresIsActive ? 'features,' : '') +
    //  (analyticsIsActive ? 'analytics,' : '') +
    //  (marketingIsActive ? 'marketing,' : '') +
    //  'expires': cookieExpires +
    //  'path=/;domain=' +
    //  hostname;
    console.log(
      'Consent',
      'cookie_consent=' +
        (featuresIsActive ? 'features,' : '') +
        (analyticsIsActive ? 'analytics,' : '') +
        (marketingIsActive ? 'marketing,' : '') +
        ';expires=' +
        cookieExpires +
        ';path=/;domain=' +
        hostname
    );
    //gtag('consent', 'update', {
    //  'ad_storage': (marketingIsActive ? 'granted' : 'denied'),
    //  'analytics_storage': (analyticsIsActive ? 'granted' : 'denied'),
    //  'featuresity_storage': (featuresIsActive ? 'granted' : 'denied')
    //});

    setSettingsVisible(false);
    setCookiebarVisible(false);
  };

  const acceptAllCookies = (delayClose) => {
    setFeaturesIsActive(true);
    setAnalyticsIsActive(true);
    setMarketingIsActive(true);
    setDelayClose(delayClose);

    setSaveValues(true);
  };

  const acceptCookies = () => {
    setSettingsVisible(false);
    setCookiebarVisible(false);

    setSaveValues(true);

    //location.reload();
    //gtag('consent', 'update', {
    //  'ad_storage': (marketingIsActive ? 'granted' : 'denied'),
    //  'analytics_storage': (analyticsIsActive ? 'granted' : 'denied'),
    //  'featuresity_storage': (featuresIsActive ? 'granted' : 'denied')
    //});
  };

  const toggleFeatures = () => {
    setFeaturesIsActive(!featuresIsActive);
    setFeaturesStatusTxt(
      featuresIsActive
        ? translate('addons.cookieconsent.disabled')
        : translate('addons.cookieconsent.active')
    );
  };
  const toggleAnalytics = () => {
    setAnalyticsIsActive(!analyticsIsActive);
    setAnalyticsStatusTxt(
      analyticsIsActive
        ? translate('addons.cookieconsent.disabled')
        : translate('addons.cookieconsent.active')
    );
  };
  const toggleMarketing = () => {
    setMarketingIsActive(!marketingIsActive);
    setMarketingStatusTxt(
      marketingIsActive
        ? translate('addons.cookieconsent.disabled')
        : translate('addons.cookieconsent.active')
    );
  };

  return (
    <Fragment>
      {showButton && (
        <button
          className="button cookie-consent__btn-edit"
          onClick={() => showSettings()}
          aria-label={translate(`addons.cookieconsent.change`)}
        >
          {translate(`addons.cookieconsent.change`)}
        </button>
      )}
      {cookiebarVisible && (
        <div className="cookie-consent">
          <div
            className="cookie-consent__btn-close"
            onClick={() => acceptAllCookies(false)}
          >
            {translate(`addons.cookieconsent.button.close.text`)}
          </div>
          {enableSettings && (
            <div
              className="cookie-consent__btn-settings"
              onClick={() => showSettings()}
              aria-label={translate(
                `addons.cookieconsent.button.settings.text`
              )}
            >
              {translate(`addons.cookieconsent.button.settings.text`)}
            </div>
          )}
          <span className="cookie-consent__info">
            {translate(`addons.cookieconsent.message`)}&nbsp;
            <a
              className="cookie-consent__link"
              href={translate(`addons.cookieconsent.moreinfo.link.url`)}
            >
              {translate(`addons.cookieconsent.moreinfo.link.msg`)}
            </a>
          </span>
        </div>
      )}
      {settingsVisible && (
        <div className="cookie-consent-settings__wrapper" ref={wrapperEl}>
          <div className="cookie-consent-settings">
            <div className="cookie-consent-settings__content">
              <div className="cookie-consent-settings__header">
                <h2 className="text--center">
                  {translate(`addons.cookieconsent.settings.header`)}
                </h2>
              </div>
              <div className="cookie-consent-settings__info">
                {translate(`addons.cookieconsent.settings.info`)}{' '}
                <a
                  className="cookie-consent__link"
                  href={translate(`addons.cookieconsent.moreinfo.link.url`)}
                >
                  {translate(`addons.cookieconsent.moreinfo.link.msg`)}
                </a>
              </div>
              <div className="small-12 columns text--center cookie-consent-settings__button-accept-all">
                <div
                  className="button"
                  onClick={() => acceptCookiesWithDelay()}
                >
                  {translate(`addons.cookieconsent.settings.acceptall`)}
                </div>
              </div>
              <div className="cookie-consent-settings__switch row">
                <div className="small-6">
                  {translate(`addons.cookieconsent.necessary`)}
                </div>
                <div className="small-6 text--right">
                  {translate(`addons.cookieconsent.alwaysactive`)}
                </div>
              </div>
              <div className="cookie-consent-settings__switch row">
                <div className="small-4 medium-6">
                  {translate(`addons.cookieconsent.features`)}
                </div>
                <div className="small-8 medium-6 text--right">
                  <label className="form__switch">
                    <span className="cookie-consent-settings__status-text">
                      {featuresStatusTxt}
                    </span>
                    <input
                      type="checkbox"
                      checked={featuresIsActive}
                      name="features"
                      onChange={() => toggleFeatures()}
                    />
                    <span className="toggle-slider round"></span>
                  </label>
                </div>
              </div>
              <div className="cookie-consent-settings__switch row">
                <div className="small-4 medium-6">
                  {translate(`addons.cookieconsent.analysis`)}
                </div>
                <div className="small-8 medium-6 text--right">
                  <label className="form__switch">
                    <span className="cookie-consent-settings__status-text">
                      {analyticsStatusTxt}
                    </span>

                    <input
                      type="checkbox"
                      checked={analyticsIsActive}
                      name="analytics"
                      onChange={() => toggleAnalytics()}
                    />
                    <span className="toggle-slider round"></span>
                  </label>
                </div>
              </div>
              <div className="cookie-consent-settings__switch row">
                <div className="small-4 medium-6">
                  {translate(`addons.cookieconsent.marketing`)}
                </div>
                <div className="small-8 medium-6 text--right">
                  <label className="form__switch">
                    <span className="cookie-consent-settings__status-text">
                      {marketingStatusTxt}
                    </span>

                    <input
                      type="checkbox"
                      checked={marketingIsActive}
                      name="marketing"
                      onChange={() => toggleMarketing()}
                    />
                    <span className="toggle-slider round"></span>
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="small-12 columns text--center">
                  <div className="button" onClick={() => acceptCookies()}>
                    {translate(`addons.cookieconsent.settings.acceptchoices`)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default CookieConsent;
